export default "__VITE_ASSET__qIn6$oOU__"